import { combineReducers } from '@reduxjs/toolkit';
import quizSlice from "../../src/Slice/quizSlice";

const rootReducer = combineReducers({
    quiz: quizSlice
});

export default rootReducer;
